import { render, staticRenderFns } from "./leaderboard_prizes.vue?vue&type=template&id=016c3360&"
import script from "./leaderboard_prizes.vue?vue&type=script&lang=js&"
export * from "./leaderboard_prizes.vue?vue&type=script&lang=js&"
import style0 from "./leaderboard_prizes.vue?vue&type=style&index=0&id=016c3360&prod&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LanguageSelection: require('/home/runner/work/mywellness-fiesta-2026/mywellness-fiesta-2026/user/components/language_selection.vue').default})
